import { clientsTableColumns } from '../../constants/tableColumns';
import { useClientContext } from '../../contexts/ClientProvider';
import useCheckUserFeaturePermissions from '../../hooks/useCheckUserFeaturePermissions';
import AcademiaNotFound from '../CommonComps/AcademiaNotFound';
import AcademiaLoading from '../CommonComps/Loadings/AcademiaLoading';
import AcademiaTable from '../CommonComps/Tables/AcademiaTable';
import PageHeader from '../CommonComps/Titles/PageHeader';
import CreateClientAction from './CreateClientAction';

const ShowAllClients = () => {
  // integration of context hooks here
  const { clientList, isError, isLoading, isSuccess } = useClientContext();

  // integration of custom hooks here
  const { featureBasedPermissions } = useCheckUserFeaturePermissions('client');

  console.log('CLIENT LIST: ', clientList);

  // rendering show all clients section component here
  return (
    <section>
      {isLoading ? (
        <AcademiaLoading />
      ) : isSuccess ? (
        featureBasedPermissions?.includes('READ') ? (
          <>
            <PageHeader headerText='All Clients' />

            <AcademiaTable
              data={clientList}
              columns={clientsTableColumns}
              tableToolbarComponent={
                <CreateClientAction
                  hasCreatePermission={featureBasedPermissions.includes(
                    'CREATE'
                  )}
                />
              }
              notFoundMessage='No client found!'
            />
          </>
        ) : (
          <AcademiaLoading />
        )
      ) : isError ? (
        <AcademiaNotFound message='Failed to load client data!!' />
      ) : null}
    </section>
  );
};

export default ShowAllClients;
